export default {
    init() {
        jQuery('#animalsArchive .locations').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Select a Location"
        });

        jQuery('#animalsArchive .age').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Select a Age"
        });

        jQuery('#animalsArchive .gender').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Select a Gender"
        });

        jQuery('#animalsArchive .otheranimals').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Search Animals"
        });

    
      
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  



// WEBPACK FOOTER //
// ./scripts/routes/templateAnimals.js